module.exports = __webpack_public_path__ + "static/media/tuiguang.9f32dd4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/tuiguang.jpg
// module id = 744
// module chunks = 2